import { __ } from "@jti/fe-common";
const CATEGORIES = ["product_types", "services"];
const NEW_CATEGORIES = [
    "product_types",
    "product_types_vending_machine",
    "services",
    "product_attributes",
    "storetype",
    "product_attributes_vending_machine",
];
export const getFiltersBaseOnFlotiqResponse = (stores, filtersTranslations) => {
    const translateFilters = (key) => {
        return filtersTranslations?.find(({ filterKey }) => filterKey === key)?.translatedFilterKey || key;
    };
    const filters = stores.reduce((acc, store) => {
        CATEGORIES.forEach((category) => {
            store[category]?.forEach((item) => {
                const filter = acc.find((filter) => filter.key === category);
                if (!filter?.filters.find((filter) => filter.key === item.key)) {
                    const name = translateFilters(item.key);
                    filter?.filters.push({
                        name: name,
                        key: item.key,
                        value: item.key,
                        label: name,
                    });
                }
            });
        });
        return acc;
    }, [
        {
            name: __("storelocator.filters.category.product_types"),
            key: "product_types",
            filters: [],
        },
        {
            name: __("storelocator.filters.category.services"),
            key: "services",
            filters: [],
        },
    ]);
    return filters;
};
const applyConfigFilters = (filters = [], filtersStatus) => {
    if (!filtersStatus)
        return filters;
    return filters.filter((filter) => {
        if (filter.key === "product_types")
            return filtersStatus.isProductTypesFilterEnabled;
        if (filter.key === "services")
            return filtersStatus.isStoreServicesFilterEnabled;
        if (filter.key === "ProductFlavours")
            return filtersStatus.isProductFlavoursFilterEnabled;
        if (filter.key === "ProductColors")
            return filtersStatus.isProductColorsFilterEnabled;
        if (filter.key === "storetype")
            return filtersStatus.isStoreTypeFilterEnabled;
        return true;
    });
};
export const getNewFiltersBaseOnFlotiqResponse = (stores, filtersTranslations, enabledFiltersCategories) => {
    const translateFilters = (key) => {
        return filtersTranslations?.find(({ filterKey }) => filterKey === key)?.translatedFilterKey || key;
    };
    const initialFiltersObj = [
        {
            name: __("storelocator.filters.category.product_types"),
            key: "product_types",
            alternativeKeys: ["product_types_vending_machine"],
            filters: [],
        },
        {
            name: __("storelocator.filters.category.product_flavours"),
            key: "ProductFlavours",
            filters: [],
        },
        {
            name: __("storelocator.filters.category.product_colors"),
            key: "ProductColors",
            filters: [],
        },
        {
            name: __("storelocator.filters.category.store_type"),
            key: "storetype",
            filters: [],
        },
        {
            name: __("storelocator.filters.category.services"),
            key: "services",
            filters: [],
        },
    ];
    const filters = stores.reduce((acc, store) => {
        NEW_CATEGORIES.forEach((category) => {
            if (category === "product_attributes" || category === "product_attributes_vending_machine") {
                store[category]?.forEach((productAttributes) => {
                    productAttributes?.values.forEach((item) => {
                        const itemValue = item.value;
                        const filter = acc.find(({ key }) => key === productAttributes.key);
                        if (filter && !filter?.filters.some(({ key }) => key === itemValue)) {
                            const name = translateFilters(itemValue);
                            filter.filters.push({
                                name: name,
                                key: itemValue,
                                value: itemValue,
                                label: name,
                            });
                        }
                    });
                });
            }
            else if (category === "storetype") {
                const storeType = store.storetype;
                const filter = acc.find((filter) => filter.key === category);
                if (!!storeType && filter && !filter?.filters.some(({ key }) => key === storeType)) {
                    const name = translateFilters(storeType);
                    filter.filters.push({
                        name: name,
                        key: storeType,
                        value: storeType,
                        label: name,
                    });
                }
            }
            else
                store[category]?.forEach((item) => {
                    const filter = acc.find((filter) => filter.key === category || filter.alternativeKeys?.includes(category));
                    if (filter && !filter?.filters.some(({ key }) => key === item.key)) {
                        const name = translateFilters(item.key);
                        filter.filters.push({
                            name: name,
                            key: item.key,
                            value: item.key,
                            label: name,
                        });
                    }
                });
        });
        return acc;
    }, initialFiltersObj);
    return applyConfigFilters(filters, enabledFiltersCategories);
};
//# sourceMappingURL=getFiltersBaseOnFlotiqResponse.js.map